export default {
  buttons: {
    add: 'Lisää',
  },
  AddOn: {
    label: 'Lisäosa',
    title: 'Hanki oma mobiilisovellus',
    subscribed: 'Tilattu',
    cta: 'Hanki oma mobiilisovellus',
    price_per_month: '{{price}} / kk',
    tax_included: 'sis. arvonlisävero',
    apple_developer_note:
      'Vaatii Apple Developer -tilin (99 $/vuosi, maksetaan Applelle) ravintolan juridiselle yhtiölle.',
    features: {
      stores: 'Listattuna App Storessa ja Google Playssa',
      push: 'Push-ilmoitukset asiakkaillesi',
      loyalty: 'Kanta-asiakaspisteet ja palkinnot',
      commission: 'Suora tilaaminen 0 %:n komissiolla',
    },
  },
};
